import type { AnyFormApi } from '@tanstack/vue-form'

/** Clears a stale form-level (pathless) blur verdict, e.g. after a caller-owned field outside the schema changes. */
export const clearFormBlurError = (form: AnyFormApi): void => {
  form.setErrorMap({ onBlur: undefined })
  form.setFieldMeta('', (meta) => ({
    ...(meta ?? {}),
    errorMap: { ...meta?.errorMap, onBlur: undefined }
  }))
}
